import { useMemo } from 'react'
import { TRANSACTION_TYPES } from 'Data/constants.js'

let CHARGE_TYPES = /** @type {const} */ ([
  TRANSACTION_TYPES.LateFeeCharge,
  TRANSACTION_TYPES.MiscFeeCharge,
  TRANSACTION_TYPES.RetailFeeCharge,
  TRANSACTION_TYPES.TxFeeCharge,
])
let ADJUSTMENT_TYPES = /** @type {const} */ ([
  TRANSACTION_TYPES.DiscountAdjustment,
  TRANSACTION_TYPES.WriteOff,
  TRANSACTION_TYPES.FixAdjustment,
  TRANSACTION_TYPES.MigrationFixAdjustment,
])
let AGGREGATED_TRANSACTION_TYPES = /** @type {const} */ ({
  Charge: 'Charge',
  Adjustment: 'Adjustment',
})

let TRANSACTION_TYPE_ORDER = /** @type {const} */ ({
  [AGGREGATED_TRANSACTION_TYPES.Charge]: 0,
  [AGGREGATED_TRANSACTION_TYPES.Adjustment]: 1,
  [TRANSACTION_TYPES.ChargeTransfer]: 2,
  [TRANSACTION_TYPES.TransferCharge]: 3,
  [TRANSACTION_TYPES.InstallmentCharge]: 4,
  [TRANSACTION_TYPES.PaymentPlan]: 5,
  [TRANSACTION_TYPES.Payment]: 6,
})

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let result = []
    for (let transaction of data) {
      if (CHARGE_TYPES.includes(transaction.dtype)) {
        if (
          result.length > 0 &&
          result[result.length - 1].dtype ===
            AGGREGATED_TRANSACTION_TYPES.Charge &&
          result[result.length - 1].sys_created_by ===
            transaction.sys_created_by
        ) {
          // an aggregation of charges it's already started, appending to it
          result[result.length - 1].entries.push(transaction)
        } else {
          // start a new aggregation entry for the charges
          result.push({
            dtype: AGGREGATED_TRANSACTION_TYPES.Charge,
            id: transaction.id,
            sys_created: transaction.sys_created,
            sys_created_by: transaction.sys_created_by,
            created_by_user: transaction.created_by_user,
            entries: [transaction],
          })
        }
      } else if (ADJUSTMENT_TYPES.includes(transaction.dtype)) {
        if (
          result.length > 0 &&
          result[result.length - 1].dtype ===
            AGGREGATED_TRANSACTION_TYPES.Adjustment &&
          result[result.length - 1].sys_created_by ===
            transaction.sys_created_by
        ) {
          // an aggregation of Adjustments it's already started, appending to it
          result[result.length - 1].entries.push(transaction)
        } else {
          // start a new aggregation entry for the Adjustments
          result.push({
            dtype: AGGREGATED_TRANSACTION_TYPES.Adjustment,
            id: transaction.id,
            sys_created: transaction.sys_created,
            sys_created_by: transaction.sys_created_by,
            created_by_user: transaction.created_by_user,
            entries: [transaction],
          })
        }
      } else {
        // no need to aggregate multiple transactions, will remain unchanged
        result.push(transaction)
      }
    }

    // Sort by sys_created first, then by transaction type order
    result.sort((a, b) => {
      // Sort by sys_created (descending - newest first)
      let dateComparison = new Date(a.sys_created) - new Date(b.sys_created)
      if (dateComparison !== 0) return dateComparison

      return TRANSACTION_TYPE_ORDER[a.dtype] - TRANSACTION_TYPE_ORDER[b.dtype]
    })

    return result
  }, [data])
}
